import React from 'react';
import { Route } from 'react-router';

import ResetPassword from '../../components/Pages/ResetPassword/ResetPasswordForm';


const routes = <Route path="resetpassword/:token" component={ResetPassword} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/resetpassword.js